import { api } from '@services';

interface IDeleteInUseTagCategory {
  id: string;
  newTagCategoryId: string;
}

const deleteInUseTagCategory = async ({
  id,
  newTagCategoryId,
}: IDeleteInUseTagCategory): Promise<void> => {
  await api.delete<void>(
    `/tagsCategory/${id}/inUse?tagCategoryId=${newTagCategoryId}`,
  );
};

export { deleteInUseTagCategory };
